import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { sendLoginCredentialsOnWhatsApp } from "../../helpers/whatsapp.helper";
import { FaPhone, FaWhatsapp, FaGlobe, FaEyeSlash } from "react-icons/fa";
import { UPLOAD_URL } from "../../utils/constants";
import { ProfileType } from "../../types";
import {
  getPrivacyOverlayLabel,
  shouldBlurProfileImage,
} from "../../utils/imagePrivacy";

type Props = {
  profileCardRef: any;
  profile: ProfileType;
};

const ProfileHeader = ({ profile, profileCardRef }: Props) => {
  const bureauInfo = useSelector((state: RootState) => state.bureau.data);
  const calculateAge = (dob: string) => {
    const birthDate = new Date(dob);
    const currentDate = new Date();
    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const month = currentDate.getMonth();
    const day = currentDate.getDate();

    if (
      month < birthDate.getMonth() ||
      (month === birthDate.getMonth() && day < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const sendWhatsApp = () =>
    sendLoginCredentialsOnWhatsApp(
      profile,
      bureauInfo?.websiteUrl,
      bureauInfo?.websiteLinks,
    );

  return (
    <div
      ref={profileCardRef}
      className={`bg-${
        profile.status === "active" ? "white" : "red-400"
      } shadow-lg rounded-lg px-6 py-4 mb-4`}
    >
      <div className="flex items-center mb-4">
        <div className="relative w-28 h-28 mr-4">
          <img
            src={UPLOAD_URL + "/users/profile_pic/" + profile.image}
            alt={"Profile"}
            className={`w-full h-full object-cover rounded-full ${
              shouldBlurProfileImage(profile.imagePrivacy)
                ? "blur-lg scale-110 brightness-90"
                : ""
            }`}
          />
          {shouldBlurProfileImage(profile.imagePrivacy) && (
            <div className="absolute inset-0 bg-black/50 rounded-full text-white text-[10px] font-semibold tracking-wide uppercase flex flex-col items-center justify-center text-center pointer-events-none px-2">
              <span>{getPrivacyOverlayLabel(profile.imagePrivacy)}</span>
            </div>
          )}
        </div>
        <div className="flex-1">
          <h2 className="text-xl font-bold">{profile.fullName}</h2>
          <p className="text-gray-800">Marital ID: {profile.martialId}</p>
          <p className="text-gray-800">
            {calculateAge(profile.dateOfBirth)} yrs | {profile.height} ft
          </p>
          <div
            className={`inline-flex items-center px-2 py-1 rounded-full text-xs mt-2 ${
              profile.visibleToAll
                ? "bg-green-100 text-green-800"
                : "bg-gray-100 text-gray-800"
            }`}
          >
            {profile.visibleToAll ? (
              <>
                <FaGlobe className="mr-1" size={12} />
                <span>Public</span>
              </>
            ) : (
              <>
                <FaEyeSlash className="mr-1" size={12} />
                <span>Private</span>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <h2 className="text-center font-bold text-red-700 mb-5">
        Profile Contact Details
      </h2>
      <div className="flex space-x-2 mb-4">
        <a
          href={`tel:${profile.mobileNumber}`}
          className="flex-1 bg-blue-500 text-white px-4 py-2 rounded-md flex items-center justify-center text-sm"
        >
          <FaPhone className="mr-2" size={16} />
          Call
        </a>
        <button
          onClick={sendWhatsApp}
          className="flex-1 bg-green-500 text-white px-4 py-2 rounded-md flex items-center justify-center text-sm"
        >
          <FaWhatsapp className="mr-2" size={16} />
          WhatsApp
        </button>
      </div>
    </div>
  );
};

export default ProfileHeader;
